import { Skeleton, SkeletonRegion } from '@parsina/framework';
import { C } from '@parsina/framework/tokens';
import { useTranslation } from '@parsina/framework/clinical/src/i18n/index';

// ─────────────────────────────────────────────────────────────────────────────
// The credits ledger while its page is pending. The hero, KPI strip
// (`KpiCard loading`), filters and toolbar all render for real; only the
// history region shimmers — one `TransactionRow` per placeholder, at the
// row's real padding (10px 16px desktop, 9px 12px mobile) with its 34/30px
// service glyph, the title + meta lines and the amount on the far side.
// ─────────────────────────────────────────────────────────────────────────────

const TxRowSkeleton = ({ i, mobile }) => (
  <div aria-hidden style={{
    display: 'flex', alignItems: 'center', gap: mobile ? 10 : 12,
    padding: mobile ? '9px 12px' : '10px 16px',
    borderTop: i > 0 ? `1px solid ${C.border}` : 'none',
  }}>
    <Skeleton width={mobile ? 30 : 34} height={mobile ? 30 : 34} radius={mobile ? 8 : 9} />
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0 }}>
      <Skeleton width={`${40 + ((i * 17) % 32)}%`} height={13} />
      <Skeleton width={`${24 + ((i * 11) % 20)}%`} height={11} />
    </div>
    <Skeleton width={mobile ? 48 : 64} height={14} />
  </div>
);

export const CreditsHistorySkeleton = ({ rows = 6, mobile = false, label }) => {
  const { t } = useTranslation();
  return (
    <SkeletonRegion label={label ?? t('common.state.loading')} data-testid="credits-history-loading">
      <div aria-hidden style={{ padding: mobile ? '5px 12px' : '6px 16px', background: C.bg }}>
        <Skeleton width={96} height={11} />
      </div>
      {Array.from({ length: rows }, (_, i) => <TxRowSkeleton key={i} i={i} mobile={mobile} />)}
    </SkeletonRegion>
  );
};

export default CreditsHistorySkeleton;
